module.exports = __webpack_public_path__ + "img/TALLER.fe4e7b69.png";